<template>
    <div class="max-width-content">
        <trashed-message v-if="company.deleted_at" class="mb-6">
            This company has been deleted.
        </trashed-message>

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link :href="route('admin.companies.index')">Bedrijven</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ company.name | truncate(35) }}
            </breadcrumbs>

            <div v-if="!company.deleted_at">
                <link-button :href="route('admin.companies.edit', company.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <confirm-button method="delete" :href="route('admin.companies.destroy', company.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</confirm-button>
            </div>
        </div>

        <div class="">


            <div class="mt-8 flex items-start justify-between">

                    
                <div class="flex-1">

                    <h1 class="text-5xl text-teal-800 mr-1 leading-tight">{{ company.name }}</h1>

                    <div v-if="company.greenness_label">
                        <i class="fad fa-leaf mr-1"></i>Greenness label: {{ company.greenness_label }}
                    </div>

                    <div v-if="company.pitch" class="mt-3 italic">
                        <span class="font-bold mr-1">Pitch:</span><span v-html="company.pitch"></span>
                    </div>

                    <div v-if="company.waarom" class="mt-3">
                        <h2 class="font-bold">Waarom</h2>
                        <div v-html="company.waarom" class="mt-3"></div>
                    </div>

                    <div v-if="company.product" class="mt-3">
                        <h2 class="font-bold">Over het product/de service</h2>
                        <div v-html="company.product" class="mt-3"></div>
                    </div>


                    <div class="mt-6 w-full">

                        <h2 class="text-xl font-bold">Gebruikers</h2>

                        <table class="w-full whitespace-no-wrap bg-white rounded" >
                        <tr
                            v-for="(user) in company.users"
                            :key="user.id"
                            class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                            
                        >
                            <td class="px-3 border-t">
                                <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.company-users.show', user.id)" tabindex="-1">
                                    {{ user.id }}
                                </inertia-link>
                            </td>

                            <td class="border-t">
                                <inertia-link class="flex items-center focus:text-teal-800 truncate justify-center" :href="route('admin.company-users.show', user.id)">
                                    <img v-if="user.avatar" :src="user.avatar" alt="" class="h-10 rounded-full" />
                                </inertia-link>
                            </td>

                            <td class="border-t">
                                <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.company-users.show', user.id)">
                                    {{ user.first_name }}
                                </inertia-link>
                            </td>

                            <td class="border-t">
                                <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.company-users.show', user.id)">
                                    {{ user.last_name }}
                                </inertia-link>
                            </td>

                            <td class="border-t">
                                <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.company-users.show', user.id)">
                                    {{ user.email }}
                                </inertia-link>
                            </td>

                        </tr>
                        </table>

                        <div class="mt-3">
                            <inertia-link :href="route('admin.company-users.index') + '?&filter_company=' + company.slug">
                                Bekijk alle gebruikers van {{ company.name }} &rarr;
                            </inertia-link>
                        </div>
                    </div>

                </div>
                <div class="bg-white px-5 py-5 rounded ml-10">

                    <div class="w-full" v-if="company.logo">
                        <img :src="company.logo" class="object-cover w-48 rounded" />
                    </div>

                    <div v-if="company.phone" class="mt-3">
                        Phone: <div v-html="company.phone"></div>
                    </div>

                    <div v-if="company.website" class="mt-3">
                        Website: <div v-html="company.website"></div>
                    </div>

                    <div v-if="company.location_name" class="mt-3">
                        Locatie: <div v-html="company.location_name"></div>
                    </div>

                    <div v-if="company.industrie_tag_id" class="mt-3">
                        Industrie: <div v-html="company.industrie_tag.name"></div>
                    </div>

                    <div v-if="company.werknemers_tag_id" class="mt-3">
                        Werknemers: <div v-html="company.werknemers_tag.name"></div>
                    </div>

                </div>

            </div>



            <div class="mt-6" v-if="company.joboffers.length">

                <h2 class="text-xl font-bold">Laatste vacatures</h2>

                <table class="w-full whitespace-no-wrap bg-white rounded" >
                <tr
                    v-for="(jobOffer) in company.joboffers"
                    :key="jobOffer.id"
                    class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                    
                >
                    <td class="px-3 border-t">
                        <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.joboffers.show', jobOffer.id)" tabindex="-1">
                            {{ jobOffer.id }}
                        </inertia-link>
                    </td>

                    <td class="border-t">
                        <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.joboffers.show', jobOffer.id)">
                            {{ jobOffer.title }}
                        </inertia-link>
                    </td>

                    <td class="border-t">
                        <inertia-link v-if="jobOffer.created_at" class="py-4 flex items-center" :href="route('admin.joboffers.show', jobOffer.id)" tabindex="-1">
                            {{ moment(jobOffer.created_at).format("DD-MM-YYYY") }}
                        </inertia-link>
                    </td>

                    <td class="border-t text-center">
                        
                        <inertia-link class="py-4 text-center" :href="route('admin.joboffers.show', jobOffer.id)" tabindex="-1">
                            <span v-if="jobOffer.published">
                                Ja <span v-if="jobOffer.published_at" class="text-sm">({{ moment(jobOffer.published_at).format("DD-MM HH:mm") }})</span>
                            </span>
                            <span v-else>Nee</span>
                        </inertia-link>
                    </td>
                    
                </tr>
                </table>

                <div class="mt-3">
                    <inertia-link :href="route('admin.joboffers.index') + '?&filter_company=' + company.slug">
                        Bekijk alle vacatures van {{ company.name }} &rarr;
                    </inertia-link>
                </div>

            </div>
            

        
            <!-- <div class="mt-10 bg-white px-5 py-3 rounded-lg">
                <h2 class="text-xl font-bold">SEO teksten</h2>

                <div class="mt-3">
                    <h3 class="text-base font-bold">Meta description:</h3>
                    <div v-if="company.seo_description" v-html="company.seo_description"></div>
                    <div v-else>Er is nog geen SEO meta description.</div>
                </div>

                <div class="mt-3">
                    <h3 class="text-base font-bold">SEO tekst boven:</h3>
                    <div v-if="company.seotext1" v-html="company.seotext1"></div>
                    <div v-else>Er is nog geen SEO tekst voor boven.</div>
                </div>

                <div class="mt-5">
                    <h3 class="text-base font-bold">SEO tekst onder:</h3>
                    <div v-if="company.seotext2" v-html="company.seotext2"></div>
                    <div v-else>Er is nog geen SEO tekst voor onder.</div>
                </div>
            </div> -->
        </div>

    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";
import ConfirmButton from "@/admin/Shared/ConfirmButton";

export default {
    metaInfo: { title: "Companies" },

    layout: Layout,

    mixins: [Helpers],

    components: { Breadcrumbs, LinkButton, ConfirmButton },

    props: {
        company: {
            Type: Object
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
